<template>
  <div class="container py-5">
    <h1 class="display-6 text-center">Virtual Learning Environment (VLE)</h1>
  <!-- Intro Section -->
    <div class="lead text-center mb-5">
      Designing and experimenting with virtual labs, authentic computing activities, 
      and interactive learning scenarios that allow students to explore, practise, 
      and reflect through hands-on experience.
    </div>
   
  </div>
   <!-- Render InfoButtons only on tab 2 -->
  <div class="card border-0 shadow-sm mb-5 p-4">
    <h5 class="text-success">Virtual Lab Experimentation (under development - coming soon!)</h5>
    <p class="mb-3">
      For learners to Observe, Interact, Experiment and Reflect. 
    </p>
    <ul class="list-group list-group-flush">
      <li class="list-group-item"><strong>Virtual Lab 1 (Networking)</strong></li>
      <li class="list-group-item"><strong>Virtual Lab 2 (IoT)</strong></li>

    </ul>
  </div>

         
</template>



<style scoped>
.nav-link {
  cursor: pointer;
}
.card-title {
  font-weight: 600;
}
.nav-link {
  background-color: #f8f9fa !important;
  color: #000 !important;
  border: 1px solid #dee2e6 !important;
}

.nav-link:hover {
  background-color: #e9f5ee !important;
  color: #000 !important;
}


.nav-link.active {
  background-color: #198754 !important;
  color: #fff !important;
  border-color: #198754 !important;
  font-weight: 600;
}

.bg-image-1 {
  background-image: url('@/assets/images/slider/linux_mental_model_1.png'); /* Replace with your image */
}





</style>
